import numeral from 'numeral';

export default {
    // Formats a number to have commas.
    formatComma(pVal) {
        while (/(\d+)(\d{3})/.test(pVal.toString())) {
            pVal = pVal.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
        }
        return pVal;
    },

    formatNumberDisplay(num, precision = 3) {
        // Handles undefined, 0, NaN (odd edge cases)
        if (!num) {
            return 0;
        }

        // In case our number is something like "18381"
        if (typeof num === 'string') {
            num = parseFloat(num);
        }

        const preciseNum = num.toPrecision(precision);

        // numeral will return NaN if it's an exponential num
        const checkNegativeExponential = new RegExp('/[-]?[0-9]*.?[0-9]+([eE][-]?[0-9]+)/g');

        if (checkNegativeExponential.exec(num)) {
            return 0;
        }

        return numeral(preciseNum).format('0[.][00]a').toUpperCase();
    },

    formatPercentDisplay(num, threshold) {
        if (threshold && !isNaN(threshold) && num < threshold) {
            const percent = threshold * 100;
            return `<${this.formatNumberDisplay(percent)}%`;
        }

        const percentNum = num * 100;
        return `${this.formatNumberDisplay(percentNum)}%`;
    },

    formatPercentDisplayWithSign(num) {
        const sign = Math.sign(num) === 1 ? '+' : '';
        return `${sign}${this.formatPercentDisplay(num)}`;
    },

    formatMultiplierDisplay(num) {
        if (num > 100) {
            return '>100x';
        } if (num < 0.05) {
            return '<0.1x';
        }

        const decimals = num < 10 ? 1 : 0;
        return `${num.toFixed(decimals)}x`;
    }
};
